import { AnalysisObjectAction } from './analysis-object-action';
import { AnalysisPathAction } from './analysis-path-action';
import { AnalysisBoolAction } from './analysis-bool-action';
import { AnalysisSelectAction } from './analysis-select-action';
import { AnalysisStringAction } from './analysis-string-action';
import { AnalysisListAction } from './analysis-list-action';
import { AnalysisInputProps } from '../types';
import { ActionInputProps } from './types';

export function AnalysisActionSwitch(props: ActionInputProps) {
  const { value, ...sharedProps } = props;
  switch (props.value._type) {
    case 'object':
      return <AnalysisObjectAction value={props.value} {...sharedProps} />;
    case 'path':
      return <AnalysisPathAction value={props.value} {...sharedProps} />;
    case 'boolean':
      return <AnalysisBoolAction value={props.value} {...sharedProps} />;
    case 'selection':
      return <AnalysisSelectAction value={props.value} {...sharedProps} />;
    case 'string':
      return <AnalysisStringAction value={props.value} {...sharedProps} />;
    case 'list':
      return <AnalysisListAction value={props.value} {...sharedProps} />;
    default:
      return <div>Type: {props.value}</div>;
  }
}
